import React from 'react';
import PropTypes from 'prop-types';
import './Header.scss';
import logo from "../../images/logo.png";
import Img from "../../components/Img/Img";

const click = (e) => {
  e.preventDefault();
  document.querySelector('html').classList.toggle('is-menu-open');
}

const Header = () => (
  <header className="header">
    <div className="menu-open-icon" onClick={click}>
      <span className="menu-open-icon-1"></span>
      <span className="menu-open-icon-2"></span>
      <span className="menu-open-icon-3"></span>
    </div>
    <a className="main-logo" href="/">
      <Img src={logo} className="main-header-logo"/>
    </a>
  </header>
);

Header.propTypes = {};

Header.defaultProps = {};

export default Header;
